import styled from 'styled-components';
import {
  white, blue, openSans,
} from '../../../utils/theme';
import { tablet, mobile, desktop } from '../../../utils/breakpoints';
import { WhiteButtonDiv } from '../../../utils/atoms';

export const Container = styled.div`
  flex-basis: calc(33% - 40px);
  margin: 20px;
  position: relative;
  background-size: cover;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  flex-direction: column;

  .xfl-profile__hover {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
  }

  > p {
    width: 100%;
  }

  @media (min-width: ${desktop.min}px) {
    &:hover {
      .xfl-profile__hover {
        opacity: 1;
      }
    }
  }

  @media(max-width: ${tablet.max}px) {
    flex-basis: calc(50% - 40px);
  }


  @media (max-width: ${mobile.max}px) {
    padding: 0 0 2vw 0;
    margin: 0 auto 30px auto;
    background-size: cover;

    &.show-quote {
      .xfl-profile__hover {
        display: flex;
        opacity: 1;
      }
    }
  }
`;

export const Front = styled.div`
  flex-grow: 0;
  position: relative;

  img {
    width: 100%;
    height: auto;
    flex-grow: 0;
  }
`;

export const TileContents = styled.div`
  position: relative;
  flex-grow: 1;
  border: 2px solid #dcdcdc;
  background: ${white};
  text-align: left;

  padding: 20px 17px;
  color: ${blue};
  font-size: 14px;
  letter-spacing: 1.3px;
  line-height: 18px;

  h4 {
    font-size: 21px;
  }

  p {
    font-size: 14px;
  }

  .strong {
    display: block;
    color: ${blue};
    font-weight: bold;
  }
`;

export const TileHover = styled.div`
  background: ${blue};
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
  bottom: 0;
  padding: 28px 33px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.5px;
  line-height: 21px;
  text-align: left;
  flex-direction: row;
  align-items: center;
  transition: all 0.15s;
  z-index: 2;


  p, li {
    ${openSans}
    font-size: 14px;
    letter-spacing: .78px;
    line-height: 25px;
    text-align: left;
    padding-bottom: 14px;
  }

  @media(max-width: ${tablet.max}px) {
    &.xfl-profile__hover--active {
      display: flex;
      opacity: 1;
    }
  }
  
  .xfl-profile__quote {
    margin-top: 0;
  }

  .xfl-profile__quote > p {
    ${openSans}
    display: inline;
    line-height: 1.2;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1.5px;
    line-height: 21px;
<<<<<<< HEAD
=======

>>>>>>> uat
    /* &:before,
    &:after {
      content: '"';
    } */
  }
`;

export const Img = styled.img`
  display: none;

  @media (max-width: ${mobile.max}px) {
    display: block;
  }
`;

export const ModalButton = styled(WhiteButtonDiv)`
  display: inline-block;
  min-width: 180px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
  &:hover {
    color: ${blue};
  }
`;



// WEBPACK FOOTER //
// ./src/components/profiles/styles/profile-tile.style.js